<div class="card m-3">
    <div class="card-body">
        <div class="row">
            <div class="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <h5 class="mt-0 mb-0 text-primary">
                    <i class="fa-regular fa-building"></i>
                    Estadísticas por compañia
                </h5>
                <div class="row">
                    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                        <div class="mt-1">
                            <a href="javascript:void(0);" class="text-decoration-none mx-1" (click)="showFilter()">
                                <i class="fa-solid fa-filter"></i>
                                Más filtros
                            </a>
                        </div>
                    </div>
                </div>
                <div class="mt-0 mb-0">
                    <button type="button" class="btn btn-secondary me-2" [routerLink]="['/statistics/main']"
                        [routerLinkActive]="'btn-primary'">
                        <i class="fa-solid fa-chart-pie"></i>
                        Generales
                    </button>
                    <button type="button" class="btn btn-secondary me-2" [routerLink]="['/statistics/professions']"
                        [routerLinkActive]="'btn-primary'">
                        <i class="fa-solid fa-user-tie"></i>
                        Profesión
                    </button>
                    <button type="button" class="btn btn-secondary me-2" [routerLink]="['/statistics/companies']"
                        [routerLinkActive]="'btn-primary'">
                        <i class="fa-regular fa-building"></i>
                        Compañia
                    </button>
                </div>
            </div>
            <div class="col-xxl-2 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                <div class="card card-dashboard">
                    <div class="card-body py-2 position-relative">
                        <h2 class="mt-0 mb-0">
                            {{indicators.singlecount.users | number}}
                        </h2>
                        <h5 class="mt-0 mb-0">
                            Usuarios
                        </h5>
                        <i class="fa-solid fa-users fa-icon-dashboard"></i>
                    </div>
                </div>
            </div>
            <div class="col-xxl-2 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                <div class="card card-dashboard">
                    <div class="card-body py-2 position-relative">
                        <h2 class="mt-0 mb-0">
                            {{indicators.singlecount.jobOffers | number}}
                        </h2>
                        <h5 class="mt-0 mb-0">
                            Oferta laborales
                        </h5>
                        <i class="fa-solid fa-briefcase fa-icon-dashboard"></i>
                    </div>
                </div>
            </div>
            <div class="col-xxl-2 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                <div class="card card-dashboard">
                    <div class="card-body py-2 position-relative">
                        <h2 class="mt-0 mb-0">
                            {{indicators.singlecount.candidates | number}}
                        </h2>
                        <h5 class="mt-0 mb-0">
                            Candidatos
                        </h5>
                        <i class="fa-solid fa-person fa-icon-dashboard"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mb-2" *ngIf="showFilters">
            <div class="card-body">
                <div class="row">
                    <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                        <div class="form-group mb-3">
                            <label>País</label>
                            <div>
                                <app-dropdown [options]="countries" [(ngModel)]="filter.countryId"
                                    (ngModelChange)="changeCountry()"></app-dropdown>
                            </div>
                        </div>
                    </div>
                    <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                        <div class="form-group mb-3">
                            <label>Provincia</label>
                            <div>
                                <app-dropdown [options]="provinces" [(ngModel)]="filter.provinceId"
                                    (ngModelChange)="changeProvince()"></app-dropdown>
                            </div>
                        </div>
                    </div>
                    <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                        <div class="form-group mb-3">
                            <label>Municipio</label>
                            <div>
                                <app-dropdown [options]="municipalities"
                                    [(ngModel)]="filter.municipalitityId"></app-dropdown>
                            </div>
                        </div>
                    </div>
                    <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                        <div class="form-group mb-3">
                            <label>Tipo de contrato</label>
                            <div>
                                <app-dropdown [options]="typeContracts"
                                    [(ngModel)]="filter.typeContractId"></app-dropdown>
                            </div>
                        </div>
                    </div>
                    <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                        <div class="form-group mb-3">
                            <label>Empresa</label>
                            <div>
                                <app-dropdown [options]="companies" [(ngModel)]="filter.companyId"></app-dropdown>
                            </div>
                        </div>
                    </div>
                    <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                        <div class="form-group mb-3">
                            <label>Profesión</label>
                            <div>
                                <app-dropdown [options]="professionalProfiles"
                                    [(ngModel)]="filter.professionalProfileId"></app-dropdown>
                            </div>
                        </div>
                    </div>
                    <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                        <div class="form-group mb-3">
                            <label>Rango de edad</label>
                            <div class="input-group">
                                <input [(ngModel)]="filter.ageRangeMin" type="number" min="0" step="1"
                                    class="form-control" placeholder="Min" />
                                <input [(ngModel)]="filter.ageRangeMax" type="number" min="0" step="1"
                                    class="form-control" placeholder="Max" />
                            </div>
                        </div>
                    </div>
                    <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                        <div class="mt-button">
                            <button type="button" class="btn btn-primary">
                                <i class="fa-solid fa-magnifying-glass"></i>
                                Buscar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr class="mt-3 mb-3" />
        <div class="row">
            <div class="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                <app-pie-chart chartId="chart-1" icon="fa-solid fa-people-group" title="Ofertas laborales publicadas"
                    [data]="indicators.jobofferpublised.data" [isLoading]="indicators.isLoading"
                    [hasError]="indicators.hasError" [isNoData]="indicators.jobofferpublised.isNoData">
                </app-pie-chart>
            </div>
            <div class="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                <app-horizontal-dar-chart chartId="chart-2" icon="fa-solid fa-people-group"
                    title="Top de empresas que más ofertas laborales publican"
                    [data]="indicators.topjobofferpublised.data" [isLoading]="indicators.isLoading"
                    [hasError]="indicators.hasError" [isNoData]="indicators.topjobofferpublised.isNoData">
                </app-horizontal-dar-chart>
            </div>
        </div>
    </div>
</div>